import React, { useEffect, useState, useCallback } from 'react';
import { Checkbox, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { userService } from '../../services/userService';
import { User } from '@/types/User';
import Colors from '../../common/color';
import { privacyService } from '../../services/privacyService';

export default function TermsAndPolicy() {
    const [accepted, setAccepted] = useState(false);
    const navigate = useNavigate();
    const [user, setUser] = useState<User | null>(null);
    const [privacy, setPrivacy] = useState<any>({});

    useEffect(() => {
        const savedUser = localStorage.getItem('user');
        if (savedUser) {
            setUser(JSON.parse(savedUser));
        }
    }, []);

    const handleAcceptTerms = async () => {
        try {
            user.isViewPolicy = '1';
            await userService.updateUser(user);
            navigate('/');
        } catch (error) {
            message.error('Có lỗi xảy ra. Vui lòng thử lại!');
        }
    };

    const fetchPrivacy = useCallback(async () => {
        try {
            const response = await privacyService.getPrivacy();
            setPrivacy(response || {});
        } catch (error) {
            message.error('Không thể tải chính sách');
        }
    }, []);

    useEffect(() => {
        fetchPrivacy();
    }, [fetchPrivacy]);

    return (
        <div className="min-h-screen bg-gray-50 py-6 sm:py-12 px-4 sm:px-6">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-2xl sm:text-3xl font-bold mb-4 sm:mb-8 text-center text-gray-800 px-4">
                    Chính sách và Điều khoản tại Hien Le Aptis
                </h1>

                <div className="bg-white p-4 sm:p-8 rounded-xl shadow-lg">
                    <div className="space-y-4 sm:space-y-6 mb-6 sm:mb-8">
                        <div
                            dangerouslySetInnerHTML={{
                                __html: privacy?.content?.replace(/\n/g, '<br />') || ''
                            }}
                            className="prose max-w-none text-gray-700 leading-relaxed text-sm sm:text-base"
                        />
                    </div>
                    <div className="border-t border-gray-200 pt-4 sm:pt-6">
                        <Checkbox
                            checked={accepted}
                            onChange={(e) => setAccepted(e.target.checked)}
                            className="mb-4 sm:mb-6"
                            style={{ color: Colors.primary }}
                        >
                            <span className="text-sm sm:text-base text-gray-700">
                                Tôi đã đọc kỹ và đồng ý với các điều khoản trên.
                                Tôi hoàn toàn chịu trách nhiệm và cam kết tuân thủ quy định này.
                            </span>
                        </Checkbox>

                        <Button
                            type="primary"
                            size="large"
                            block
                            disabled={!accepted}
                            onClick={handleAcceptTerms}
                            className="h-10 sm:h-12 text-base sm:text-lg font-medium"
                            style={accepted ? { backgroundColor: Colors.primary, color: Colors.white } : {}}
                        >
                            Tiếp tục
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
} 